import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class PostalCodeColumn extends Column {
    title = 'company.offices.postalCodeColumn';
    property = 'postalCode';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
}
